import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {SampleComponent} from "./sample.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/sample-v2', {template: ''});
    }]);
/***/

const sampleRoutes: Routes = [
    {path: 'sample-v2', component: SampleComponent},
    {path: 'cars-sara-v2/web/sample-v2', component: SampleComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(sampleRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class SampleRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/sample-v2/sample-routing.module.ts